import React from "react";
import styled from "styled-components";

const ContentStyle = styled.div`
  h2 {
    color: #333333;
    margin: 30px 0;
  }
  .desc {
    color: #7d8a96;
    font-size: 15px;
    line-height: 26px;
    padding-bottom: 40px;
    border-bottom: 1px solid #aeb7c1;
    .item {
      margin-bottom: 20px;
    }
    > .number {
      list-style: decimal;
      padding-left: 20px;
      li {
      }
    }
  }
  h3 {
    color: #142a3f;
    margin-bottom: 20px;
  }
  .list-piece {
    line-height: 24px;
    font-size: 16px;
    color: #7d8a96;
    list-style: decimal;
    margin-bottom: 40px;
    > li {
      margin-left: 20px;
      margin-bottom: 10px;
    }
    .sub-list {
      padding-left: 15px;
      list-style: decimal;
    }
  }
  .md-40 {
    margin-bottom: 40px;
  }
  .flex-j {
    display: flex;
    flex-wrap: wrap;
  }
  @media (max-width: 768px) {
    h2 {
      margin: 20px 0;
    }
  }
`;

const W66 = styled.div`
  width: 66.6%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const W33 = styled.div`
  width: 33.3%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export default function Content(props) {
  return (
    <ContentStyle>
      <div className="flex-j">
        <W66>
          <h2 className="h2">An NFT Auction Model and Mechanism</h2>
          <div className="desc">
            <h3 className="h3">An NFT protocol with auction mechanism</h3>
            <p className="item">
              The academic grant initiated by DAOeco is an NFT auction model and
              mechanism, which can improve the liquidity in NFT trading market,
              help NFT creators and participants benefit from the combination of
              NFT and Defi.
            </p>
            <p className="item">
              This Grant will be open to all Trias holders. All participants
              will receive a Wisdom Key and an LV1 Contribution Medal to mark
              their support for DAOeco. The Wisdom Key and Contribution Medal
              are worth collecting, and can also be used in other Trias events.
            </p>
            <p className="item">
              Previously, DAOeco, an organization initiated by Trias community
              and focuses on the research of token economic model, has designed
              a <a href="/#/donate">Quadric Voting grant model</a>, expanding
              the influence of the ordinary and making voting fairer in
              participating in community governance.
            </p>
          </div>

          <div className="desc" style={{ marginTop: 15 }}>
            <h3 className="h3">Research Background</h3>
            <p className="item">
              Since Christie's first auction of artist Beeple's NFT artwork in
              March this year, which was sold for nearly $70 million, the niche
              but imaginative NFT art market has gradually warmed up.
            </p>
            <p className="item">
              Encryption arts is the fastest-growing field in NFT. It employs
              blockchain to serve or create digital artworks, realizes the
              display and transaction of artworks in virtual space, makes art
              investment beyond traditional material forms, and makes it
              possible to collect digital artworks.
            </p>
            <p className="item">
              On the Internet, the reproduction and dissemination of digital
              works become rampant, and it is often very difficult to verify and
              trace the identity of the creator of a work. NFT is indivisible,
              irreplaceable and unique, and it can be any type of media,
              therefore, it can represent the ownership of basic assets,
              especially digital assets. In this perspective, NFT can be simply
              understood as a digital collection using blockchain technology for
              authentication.
            </p>
            <p className="item">
              Although NFT solves the ownership problem of digital art, as an
              emerging technology and product, there are also some problems with
              NFT itself:
            </p>
            <ul className="number">
              <li className="item">
                <p>Lack of liquidity</p>
                Based on the match of counterparties, NFT transaction requires
                both the buyer and the seller to bid repeatedly to reach the
                transaction, thus the transaction efficiency is low;{" "}
              </li>
              <li className="item">
                <p>The creator can only get income once</p>
                Encryption artists or copyright owners can only get the income
                from the first issue of their artworks, rather than the
                secondary market once the NFT is issued.
              </li>
              <li className="item">
                <p>The creators have little right to judge or show artworks</p>
                The right to price artworks is often controlled by top
                collectors rather than ordinary people or creators. A large
                number of potential artists lack the opportunity to exhibit
                their artworks and gain income from them.
              </li>
            </ul>

            <h3 className="h3">Research Theme</h3>
            <p className="item">An NFT protocol with auction mechanism</p>

            <h3 className="h3">Brief Introduction</h3>
            <p className="item">
              In view of the current problems of NFT, DAOeco will learn from the
              theory of the Radical Market, modify the model of NFT trading, and
              then put forward a new NFT production and auction mechanism.
            </p>
            <p className="item">
              In the new model, the auction will never end. As long as someone's
              bid is 10% higher than the previous bidder's, the system will
              transfer the ownership of the NFT automatically. This design gives
              all NFTs a natural automatic bidding mechanism, improves the
              liquidity of assets, and realizes the autonomy of value. Encrypts
              artworks can be independent of platforms and are possible to be a
              public commodity.
            </p>
            <p className="item">
              Under such a mechanism, encrypted artworks are endowed with both
              collection and speculation properties, which can meet the needs of
              different types of bidders. The creator becomes the shareholder of
              the artworks and enjoys the benefits of the future bidding
              premium. Both the protocol creator and trader can benefit from the
              mechanism.
            </p>

            <h3 className="h3">Expected Outcome</h3>
            <p className="item">
              This NFT model with an auction mechanism can effectively maximize
              the expected revenue of the auctioneers and achieve the highest
              value of the artworks. At the same time, it gives users (bidders)
              a fair auction mechanism. DAOeco will launch this NFT mechanism as
              soon as possible and also improve it continuously to bring artists
              and users the most perfect auction mechanism and auction
              experience.
            </p>

            <h3 className="h3">About DAOeco</h3>
            <p className="item">
              DAOeco is an organization initiated by Trias community and focuses
              on the research of the token economic model. DAOeco is composed of
              a group of economy enthusiasts from all over the world, including
              economists, researchers, university professors, etc. who hope to
              put forward a reasonable economic mechanism and governance model
              through theoretical research, to provide an efficient and feasible
              scheme for the certificate economy design of the project.
            </p>
            <p className="item">
              DAOeco will collect ideas from the community, and conduct research
              and analysis, and design token economic models.
            </p>
            <p className="item">
              DAOeco receives grants from the community. In return, Grant
              contributors can obtain the memorial NFTs from DAOeco.
            </p>
          </div>
        </W66>
        <W33>{props.children}</W33>
      </div>
      <W66>
        <h2 className="h2">Grant Details</h2>
        <ul className="list-piece">
          <li>Grant participants: TRIAS holders</li>
          <li>Grant period: 30 days</li>
          <li>Grant token: TRIAS</li>
          <li>Wallet type: BSC wallet</li>
          <li>Grant hardcap: 1000 TRIAS</li>
          <li>Grant softcap: 50 TRIAS</li>
        </ul>
      </W66>
      <W66>
        <h2 className="h2">Grant Guideline</h2>
        <ul className="list-piece md-40">
          <li>
            Get TRIAS from exchanges or PancakeSwap and withdraw to your
            personal BSC wallet.
          </li>
          <li>
            Connect your personal wallet and grant TRIAS to support the specific
            grant.
          </li>
          <li>Wait for the grant to end.</li>
          <li>
            If the project is successfully launched, the initiator can use the
            corresponding TRIAS token to organize the related activities.
            Meanwhile, you will be notified of the progress.
          </li>
          <li>
            If the project fails (raised less than the soft cap), your TRIAS
            will be returned.
          </li>
        </ul>
      </W66>
      <W66 style={{ marginBottom: 30 }}>
        <h2 className="h2">Grant Rewards</h2>
        <p
          style={{
            color: "#7d8a96",
            fontSize: 16,
          }}
        >
          You will get a Wisdom Key and a Contribution Medal（LV1）as a
          recognition and appreciation of this grant. You can check it out at:{" "}
          <a href="https://nft.trias.one/warehouse" target="_black">
            https://nft.trias.one/warehouse
          </a>{" "}
          after you have contributed the grant.
        </p>
      </W66>
    </ContentStyle>
  );
}
